import useIsEmea from "@dana/Common/Hooks/useIsEmea";
import { formatDateYYYYMMDD } from "@dana/Common/utils";
import isApiError from "@insite/client-framework/Common/isApiError";
import {
    replaceInChain
} from "@insite/client-framework/HandlerCreator";
import { addWishListLines } from "@insite/client-framework/Services/WishListService";
import { AddLineToWishList, chain } from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";


// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

// trying to reference a handler not in the chain will result in a warning and the chain will not be modified
replaceInChain(
    chain,
    AddLineToWishList,
    async props => {

        if (!props.result.wishList) {
            return;
        }

        try {


            const lines = props.parameter.productInfos.map((productInfo: any) => {

                const shipDate = productInfo?.properties?.requestedShipDate;
                return {
                    productId: productInfo.productId,
                    qtyOrdered: productInfo.qtyOrdered,
                    unitOfMeasure: productInfo.unitOfMeasure,
                    properties: {
                        requestedShipDate: shipDate,
                    } as any,
                };
            });

            await addWishListLines({ wishList: props.result.wishList, lines });
        } catch (error: any) {
            if (isApiError(error) && error.status === 400) {
                props.result.errorMessage = error.errorJson.message;
                return;
            }
            if (error?.status === 404) {
                props.result.errorMessage = error.errorMessage;
                return;
            }
            throw error;
        }
    },
);
